var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"width-1280",class:{'bb-2': !_vm.borderTop},attrs:{"id":"loginTop"}},[_c('router-link',{attrs:{"to":_vm.basePath + '/shop/shopIndex'}},[_c('img',{staticClass:"mid cursor",attrs:{"src":require("../assets/logo-r.png")}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }